export const products = [
  { id: 'terramar', label: 'TERRAMAR' },
  { id: 'nfinity', label: 'N-FINITY™' },
];
